'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _desc, _value, _class, _class2, _temp;

var _templateObject = (0, _taggedTemplateLiteral3.default)(['', ''], ['', '']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Data = require('./Data');

var _Data2 = _interopRequireDefault(_Data);

var _reactApollo = require('react-apollo');

var _graphqlTag = require('graphql-tag');

var _graphqlTag2 = _interopRequireDefault(_graphqlTag);

var _getQueryFields = require('./getQueryFields');

var _getQueryFields2 = _interopRequireDefault(_getQueryFields);

var _getParams = require('./getParams');

var _Head = require('./Head');

var _Head2 = _interopRequireDefault(_Head);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _debounce = require('./debounce');

var _debounce2 = _interopRequireDefault(_debounce);

var _isEqual = require('lodash/isEqual');

var _isEqual2 = _interopRequireDefault(_isEqual);

var _pick = require('lodash/pick');

var _pick2 = _interopRequireDefault(_pick);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _LoadingIndicator = require('./LoadingIndicator');

var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var Fetch = (_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(Fetch, _React$Component);

  function Fetch(props) {
    (0, _classCallCheck3.default)(this, Fetch);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Fetch.__proto__ || Object.getPrototypeOf(Fetch)).call(this, props));

    _this.state = {
      page: 1,
      limit: _this.props.defaultLimit,
      variables: {}
    };
    _this.createChild(props);
    return _this;
  }

  // public reload function


  (0, _createClass3.default)(Fetch, [{
    key: 'reload',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt('return', this.refs.child.refs.child.queryObservable.refetch());

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function reload() {
        return _ref.apply(this, arguments);
      }

      return reload;
    }()
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var newQuery = this.getQuery(nextProps);
      var currentQuery = this.getQuery(this.props);
      if (newQuery !== currentQuery) {
        this.createChild(nextProps);
      }

      var newVariables = this.getVariables(nextProps);
      var currentVariables = this.getVariables(this.props);
      if (!(0, _isEqual2.default)(newVariables, currentVariables) && this.state.page !== 1) {
        this.setState({ page: 1 });
      }
    }
  }, {
    key: 'createChild',
    value: function createChild(props) {
      var _this2 = this;

      var queryContainer = (0, _reactApollo.graphql)((0, _graphqlTag2.default)(_templateObject, this.getQuery(props)), {
        options: function options(_ref2) {
          var variables = _ref2.variables;

          return {
            variables: variables,
            fetchPolicy: 'network-only',
            pollInterval: _this2.props.pollInterval ? _this2.props.pollInterval : null
          };
        }
      });
      var child = queryContainer(_Data2.default);
      this.Child = (0, _debounce2.default)(child);
    }
  }, {
    key: 'getQuery',
    value: function getQuery(props) {
      return 'query paginated_' + this.props.queryName + ' (\n      $page: Int\n      $limit: Int\n      $sortBy: String\n      $sortType: SortType\n      ' + this.props.params + ') {\n      result: ' + this.props.queryName + ' (\n        page: $page\n        limit: $limit\n        sortBy: $sortBy\n        sortType: $sortType\n        ' + (0, _getParams.getQueryParams)(this.props.params) + '\n      ) {\n        _id\n        totalCount\n        totalPages\n        hasNextPage\n        hasPreviousPage\n        items ' + (0, _getQueryFields2.default)(this.props.fields, this.props.extraFields) + '\n      }\n    }';
    }
  }, {
    key: 'getDefaultSort',
    value: function getDefaultSort() {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.props.fields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var field = _step.value;

          if (field.defaultSort) {
            return {
              sortBy: field.name,
              sortType: field.defaultSort
            };
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return {};
    }
  }, {
    key: 'getVariables',
    value: function getVariables(props) {
      var _this3 = this;

      var defaultSort = this.getDefaultSort();
      var variables = {
        limit: this.state.limit,
        page: this.state.page,
        sortBy: this.state.sortBy || defaultSort.sortBy,
        sortType: this.state.sortType || defaultSort.sortType
      };
      var params = (0, _getParams.getVariables)(props.params);
      var varsInProps = (0, _pick2.default)(props, params) || {};
      params.forEach(function (variable) {
        variables[variable] = _this3.state.variables[variable] || varsInProps[variable];
      });
      return variables;
    }
  }, {
    key: 'setVariable',
    value: function setVariable(key, value) {
      var variables = this.state.variables;
      variables[key] = value;
      this.setState({ variables: variables, page: 1 });
    }
  }, {
    key: 'setSort',
    value: function setSort(sortBy, sortType) {
      this.setState({ sortBy: sortBy, sortType: sortType });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var variables = this.getVariables(this.props);
      return _react2.default.createElement(
        'div',
        { className: 'paginated-root' },
        _react2.default.createElement(_Head2.default, {
          ref: 'head',
          title: this.props.headTitle,
          bottomComponent: this.props.headBottomComponent,
          leftComponent: this.props.headLeftComponent,
          centerComponent: this.props.headCenterComponent,
          rightComponent: this.props.headRightComponent,
          variables: variables,
          setVariable: this.setVariable
        }),
        _react2.default.createElement(this.Child, {
          ref: 'child',
          selectedItemId: this.props.selectedItemId,
          variables: variables,
          onPress: this.props.onPress,
          fields: this.props.fields,
          sortBy: variables.sortBy,
          sortType: variables.sortType,
          setSort: this.setSort,
          page: variables.page,
          setPage: function setPage(page) {
            return _this4.setState({ page: page });
          },
          limit: variables.limit,
          setLimit: function setLimit(limit) {
            return _this4.setState({ limit: limit });
          },
          loadingComponent: this.props.loadingComponent
        })
      );
    }
  }]);
  return Fetch;
}(_react2.default.Component), _class2.propTypes = {
  /**
   * Head title
   */
  headTitle: _propTypes2.default.any,
  /**
   * Head bottom component
   */
  headBottomComponent: _propTypes2.default.func,
  /**
   * Head center component
   */
  headCenterComponent: _propTypes2.default.func,
  /**
   * Head left component
   */
  headLeftComponent: _propTypes2.default.func,
  /**
   * Head right component
   */
  headRightComponent: _propTypes2.default.func,
  /**
   * Name of the query. Ex: backendEvents, producers
   */
  queryName: _propTypes2.default.string.isRequired,
  /**
   * Fields to display
   */
  fields: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    /**
    * Title in the header
    */
    title: _propTypes2.default.string,
    /**
    * A render function
    * Args: (value, doc, index)
    */
    render: _propTypes2.default.func,
    /**
    * Name of the field
    */
    name: _propTypes2.default.string.isRequired,
    /**
    * The default sort when activated. If present it can sort by this field. ASC or DESC
    */
    sort: _propTypes2.default.string,
    /**
    * If this is the default field to sort, the value should be the sort type. ASC or DESC
    */
    defaultSort: _propTypes2.default.string
  })).isRequired,
  /**
   * Extra fields to bring
   */
  extraFields: _propTypes2.default.arrayOf(_propTypes2.default.string),
  /**
   * Declare the graphql params for the query
   */
  params: _propTypes2.default.string,
  /**
   * When use choose the item
   */
  onPress: _propTypes2.default.func,
  /**
   * Apollo poll interval for refetch, default to 20s. Set to null to deactivate. In seconds
   */
  pollInterval: _propTypes2.default.number,
  /**
   * Pass the id of the selected item to highlight then in the table
   */
  selectedItemId: _propTypes2.default.string,
  /**
   * Default limit
   */
  defaultLimit: _propTypes2.default.number,
  /**
   * Loading component
   */
  loadingComponent: _propTypes2.default.any
}, _class2.defaultProps = {
  params: '$filter: String',
  headCenterComponent: function headCenterComponent() {
    return _react2.default.createElement('div', null);
  },
  headBottomComponent: function headBottomComponent() {
    return _react2.default.createElement('div', null);
  },
  onPress: function onPress() {},
  pollInterval: 0,
  defaultLimit: 10,
  loadingComponent: _LoadingIndicator2.default
}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'setVariable', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'setVariable'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'setSort', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'setSort'), _class.prototype)), _class);
exports.default = Fetch;


//////////////////
// WEBPACK FOOTER
// ./node_modules/meteor-paginated-graphql-react/lib/index.js
// module id = 668
// module chunks = 85